module.exports = __webpack_public_path__ + "static/sponsor-21436724863beefb8da35230f9fb439e.svg";